import {Component, input} from '@angular/core';
import {NgClass, NgTemplateOutlet} from "@angular/common";
import {PageRedirect} from "../../../helpers/page-redirect";
import {TemplateAndValue} from "../../../helpers/template-and-value";
import {
  KeyValuePairTableSingleValueType,
  KeyValuePairTableData
} from "../../../helpers/key-value-pair-table-value-type";
import {LocalMomentPipe} from "../../../pipes/local-moment.pipe";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'key-value-pair-table',
  standalone: true,
  imports: [
    NgTemplateOutlet,
    LocalMomentPipe,
    RouterLink,
    NgClass
  ],
  templateUrl: './key-value-pair-table.component.html',
  styleUrl: './key-value-pair-table.component.css'
})
export class KeyValuePairTableComponent {
  data = input.required<KeyValuePairTableData[]>();
  protected readonly Array = Array;

  isValueDate(value: KeyValuePairTableSingleValueType) {
    return value instanceof Date;
  }

  isValuePageLink(value: KeyValuePairTableSingleValueType) {
    return value instanceof PageRedirect;
  }

  isValueTemplate(value: KeyValuePairTableSingleValueType) {
    return value instanceof TemplateAndValue;
  }
}
